import { Moment, isMoment } from 'moment';

export function serializeDateOnly(date: Moment) {
     return isMoment(date) && date.isValid()
        ? date.format('YYYY-MM-DD')
        : null;
}

export function serializeDateTimeOffset(date: Moment): string {
    return isMoment(date) && date.isValid()
        ? encodeURIComponent(date.format('YYYY-MM-DDTHH:mm:ssZ')) // encode +12:00 to %2B12:00
        : null;
}
